import { useState } from "react";
import { faqList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-3xl mx-auto">
        <SectionHeading
          eyebrow="常见问题"
          title="关于分类、画风与阅读的常见疑问"
          desc="把最多人问到的几个问题集中放在这里，看完基本能立刻开始阅读。"
        />

        <div className="mt-10 flex flex-col gap-3">
          {faqList.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={item.q}
                className={`rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  className="w-full flex items-start justify-between gap-4 text-left px-5 py-4 cursor-pointer"
                >
                  <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                    {item.q}
                  </span>
                  <span
                    className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-sm`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}